import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, useLoaderData } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import { createApi } from "~/api/createApi.server";
import { WebviewNavBar } from "~/components/WebviewNavBar";
import { useWebviewInterface } from "~/hooks/useWebviewInterface";
import type { GetTermPayload } from "~/payloads";

export async function loader({ request }: LoaderFunctionArgs) {
  const api = await createApi(request);

  const data = await api.getJson<GetTermPayload>({
    endpoint: "/_/aa00/legals/venus_term",
  });

  return json({
    data,
  });
}

export default function Legals() {
  const { t } = useTranslation("common");
  const { data } = useLoaderData<typeof loader>();
  const webviewInterface = useWebviewInterface();

  return (
    <div>
      {!webviewInterface?.AppNavAvailable ? (
        <WebviewNavBar title={t("legals")} />
      ) : null}
      <div
        dangerouslySetInnerHTML={{
          __html: data.result[0].description,
        }}
      />
    </div>
  );
}
